import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=5e322d6e&"
import script from "./ModalFrame.vue?vue&type=script&lang=js&"
export * from "./ModalFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports